module.exports = __webpack_public_path__ + "img/related-logo.91f416ea.png";